import React from "react";
import PaymentRequiestPageSection from "../../Sections/PaymentRequiestPageSection/Content";
const PaymentRequiestPage = () => {
  return <PaymentRequiestPageSection />;
};

export default PaymentRequiestPage;
